module.exports = __webpack_public_path__ + "static/media/inpersonTour.f515bf53.svg";